export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const REMOVE = 'REMOVE';
export const LOAD = 'LOAD';
export const SWAP = 'SWAP';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export const MODAL = 'MODAL';
